import { render, staticRenderFns } from "./AboutQuote.vue?vue&type=template&id=4a0eb339&scoped=true&"
import script from "./AboutQuote.vue?vue&type=script&lang=js&"
export * from "./AboutQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0eb339",
  null
  
)

export default component.exports